import { useCallback, useEffect, useState } from "react";
import EmailInput from "./Inputs/EmailInput";
import PhoneInput from "react-phone-input-2";
import JurCompanyNameInput from "./Inputs/JurCompanyNameInput";
import JurAddressInput from "./Inputs/JurAddressInput";
import TaxDepartmentInput from "./Inputs/TaxDepartmentInput";
import TaxNumberInput from "./Inputs/TaxNumberInput";
import JurPersonPostInput from "./Inputs/JurPersonPostInput";
import JurFullNameInput from "./Inputs/JurFullNameInput";
import { useDispatch, useSelector } from "react-redux";
import { selectIsEditingMode, selectIsSaving, selectUser, setIsEditingMode, setIsSaving, updateUser } from "../userSlice";

import style from '../../../sass/pages/profile/profile.module.scss'
import { pushAlert } from "../../alerts/alertSlice";

import { validateUser } from "../../../validators/validateUser"
import SenderCityInput from "./Inputs/SenderCityInput";
import { useTranslation } from "react-i18next";
import LanguageInput from "./Inputs/LanguageInput";
import SenderTownInput from "./Inputs/SenderTownInput";
import SenderDistrictInput from "./Inputs/SenderDistrictInput";

const JurInputs = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch()
    const isEditing = useSelector(selectIsEditingMode);
    const user = useSelector(selectUser);
    const isSaving = useSelector(selectIsSaving)

    const [companyName, setCompanyName] = useState("");
    const [senderCity, setSenderCity] = useState("");
    const [senderTownID, setSenderTownID] = useState("")
    const [initialSenderDistrict, setInitialSenderDistrict] = useState("");
    const [senderDistictID, setSenderDistrictID] = useState("")
    const [jurAddress, setJurAddress] = useState("");
    const [taxDepartment, setTaxDepartment] = useState("");
    const [taxNumber, setTaxNumber] = useState("");
    const [personName, setPersonName] = useState("");
    const [personPost, setPersonPost] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [language, setLanguage] = useState("tr");

    useEffect(() => {
        if (user) {
            setLanguage(user.language ?? "tr");
            setCompanyName(user["company-name"] ?? "");
            setJurAddress(user["juridical-address"] ?? "");
            setSenderCity(user["sender-city-code"] ?? "");
            setSenderTownID(user["sender-town-id"] ?? "");
            setInitialSenderDistrict(user["sender-district-id"] ?? "")
            setTaxDepartment(user["tax-department"] ?? "");
            setTaxNumber(user["tax-number"] ?? "");
            setPersonName(user["person-full-name"] ?? "");
            setPersonPost(user["person-post"] ?? "");
            setEmail(user.email ?? "");
            setPhone(user["phone-number"] ?? "");
        }
    }, [user]);


    const getData = useCallback(() => {
        return {
            language,
            "user-type": user["user-type"],
            "company-name": companyName,
            "sender-city-code": senderCity,
            "sender-town-id": +senderTownID,
            "sender-district-id": +senderDistictID,
            "juridical-address": jurAddress,
            "tax-department": taxDepartment,
            "tax-number": taxNumber,
            "person-full-name": personName,
            "person-post": personPost,
            email,
            "phone-number": phone,
        }
    }, [companyName, email, jurAddress, language, personName, personPost, phone, senderCity, senderDistictID, senderTownID, taxDepartment, taxNumber, user]);

    useEffect(() => {
        if(initialSenderDistrict)
            setSenderDistrictID(initialSenderDistrict);
    }, [initialSenderDistrict])

    useEffect(() => {
        if (!isSaving || !user["user-type"]) {
            return;
        }
        let errors = validateUser(getData());
        console.log("errors:", errors);
        if (errors.length > 0) {
            dispatch(setIsSaving(false));
            dispatch(setIsEditingMode(true))

            errors.map((error) =>
                dispatch(
                    pushAlert({
                        message: t(error),
                        delay: 3000,
                        type: "danger",
                    })
                )
            );

            return;
        }

        dispatch(
            updateUser({
                data: getData()
            })
        )
        dispatch(setIsSaving(false));
        dispatch(setIsEditingMode(false));
    }, [dispatch, getData, isSaving, user]);

    return (
        <div className="flex flex-col gap-4">
            <LanguageInput 
                state={language} 
                setState={setLanguage} 
                enabled={isEditing} 
            />
            <JurCompanyNameInput
                state={companyName}
                setState={setCompanyName}
                enabled={isEditing}
            />
            <SenderCityInput 
                state={senderCity}
                setState={setSenderCity}
                enabled={isEditing}
            />
            <SenderTownInput 
                state={senderTownID}
                setState={setSenderTownID}
                enabled={isEditing}
                senderCityCode={senderCity}
            />
            <SenderDistrictInput 
                state={senderDistictID}
                setState={setSenderDistrictID}
                enabled={isEditing}
                senderTownID={senderTownID}
                initialID={initialSenderDistrict}
            />
            <JurAddressInput
                state={jurAddress}
                setState={setJurAddress}
                enabled={isEditing}
            />
            <TaxDepartmentInput
                state={taxDepartment}
                setState={setTaxDepartment}
                enabled={isEditing}
            />
            <TaxNumberInput
                state={taxNumber}
                setState={setTaxNumber}
                enabled={isEditing}
            />
            <JurFullNameInput
                state={personName}
                setState={setPersonName}
                enabled={isEditing}
            />
            <JurPersonPostInput
                state={personPost}
                setState={setPersonPost}
                enabled={isEditing}
            />
            <EmailInput state={email} setState={setEmail} enabled={isEditing} />
            <div className="grid grid-cols-8 xs:grid-cols-12 items-center">
                <span className='col-span-4 text-xs text-left font-bold'>
                    {t("user.inputs.phone.title")}
                </span>
                    <PhoneInput 
                        disabled={!isEditing}
                        value={phone}
                        onChange={(e) => setPhone(e)}
                        country={"tr"}
                        inputClass={`${style.input} col-span-12 xs:col-span-8`}
                        specialLabel=""
                        className="col-span-8"
                    />
            </div>
        </div>
    );
};

export default JurInputs;
